import React from "react";
import TitlePage from "./TitlePage";
import TitlePageMenu from "./TitlePageMenu";
import { Box, Grid, Paper } from "@mui/material";

export default function ContentPage({
  title,
  userTitle,
  TitlePageMenulist,
  children,
  secondaryTitile,
  warning,
  btnAction,
  image_icon,
}) {
  return (
    <>
      <TitlePage
        title={title}
        image_icon={image_icon}
        userTitle={userTitle}
        warning={warning}
      >
        <Grid container direction="row" justifyContent="space-between">
          <Grid item xs={12} md={6}>
            <TitlePageMenu list={TitlePageMenulist} />
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            {btnAction}
          </Grid>
        </Grid>
        <Grid
          sx={{ display: { display: secondaryTitile ? "flex" : "none" } }}
          container
          direction="row"
          justifyContent="center"
        >
          <Grid item xs={12} md={12}>
            {secondaryTitile}
          </Grid>
        </Grid>
      </TitlePage>
      {/* <Paper elevation={1} sx={{ p: 2, borderRadius: 2, mt: 2 }}> */}
      <Box sx={{ mt: 3 }}>{children}</Box>
      {/* </Paper> */}
    </>
  );
}
